import request from "@/axios/index";

export function formConfig({ method, reqInfo, id }) {
  return request({
    url: id ? `/formConfig/${id}` : `/formConfig`,
    method,
    [method === "get" ? "params" : "data"]: reqInfo,
  });
}
export function formConfigFind() {
  return request({
    url: "/formConfig/selectAll",
    method: "get",
  });
}
// 复制到表单
export function copyToform(id) { 
  return request({
    url: `itemsConfig/synchronize?formId=${id}`,
    method: "get"
  })
}
// 复制到表格
export function copyTokey(id) { 
  return request({
    url: `fieldsConfig/synchronize?formId=${id}`,
    method: "get"
  })
}


